module.exports = __webpack_public_path__ + "static/media/inceleme_videosu_ADIM1.25b31b4d.jpg";